import { ControlsToggleExtraContent, LayoutComponent } from "packages/lesson/dist/@types";
import config from "appConfig";

export const component: LayoutComponent[] = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/02/07/principle/wind-turbine.svg`,
          styles: {
            width: "80%",
          },
        },
      },
    },
  },
];

export const extraContent: ControlsToggleExtraContent = [
  {
    type: "audioButton",
    options: {
      text: "Sound sample",
      shape: "round",
      theme: "secondary",
      icon: "cis-volume-high",
      url: `${config.ASSETS_URL}/02/07/principle/wind-turbine.wav`,
    },
  },
];
